import { TransactionStatus } from "@modules/finances/types/financesType"
import { z } from "zod"

export const CustomerHistoryDtoSchema = z.object({
  transactionId: z.string(),
  name: z.string().nullable(),
  amount: z.number(),
  currency: z.string(),
  date: z.string(),
  status: z.nativeEnum(TransactionStatus),
})

export type CustomerHistoryDto = z.infer<typeof CustomerHistoryDtoSchema>
